module.exports = __webpack_public_path__ + "static/media/detail_0029_t.5d91eeca.jpg";